module.exports = __webpack_public_path__ + "img/free-tip-pc.3884b14c.png";